"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledReportOverviewCard = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledReportOverviewCard = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  :not(:last-child) {\n    margin-right: ", ";\n  }\n\n  .card-header {\n    padding: ", ";\n    display: flex;\n    justify-content: center;\n\n    h1 {\n      font-size: ", ";\n    }\n  }\n\n  .card {\n    .card-body {\n      ", ";\n      justify-content: space-between;\n      flex-direction: column;\n      padding: ", ";\n    }\n  }\n\n  ul {\n    list-style-type: none;\n    padding: 0;\n\n    li {\n      display: flex;\n      align-items: flex-start;\n      font-size: ", ";\n    }\n\n    i {\n      font-size: ", ";\n      color: ", ";\n    }\n  }\n\n  button {\n    height: 40px;\n    width: 208px;\n    letter-spacing: 2px;\n    background-color: ", ";\n    border-color: ", ";\n    ", ";\n\n    &:hover {\n      background-color: ", ";\n      border-color: ", ";\n    }\n  }\n"], ["\n  :not(:last-child) {\n    margin-right: ", ";\n  }\n\n  .card-header {\n    padding: ", ";\n    display: flex;\n    justify-content: center;\n\n    h1 {\n      font-size: ", ";\n    }\n  }\n\n  .card {\n    .card-body {\n      ", ";\n      justify-content: space-between;\n      flex-direction: column;\n      padding: ", ";\n    }\n  }\n\n  ul {\n    list-style-type: none;\n    padding: 0;\n\n    li {\n      display: flex;\n      align-items: flex-start;\n      font-size: ", ";\n    }\n\n    i {\n      font-size: ", ";\n      color: ", ";\n    }\n  }\n\n  button {\n    height: 40px;\n    width: 208px;\n    letter-spacing: 2px;\n    background-color: ", ";\n    border-color: ", ";\n    ", ";\n\n    &:hover {\n      background-color: ", ";\n      border-color: ", ";\n    }\n  }\n"])), function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x4;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return "".concat(Spacing.x3, " ").concat(Spacing.x4);
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('vertical');
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return "0 ".concat(Spacing.x3, " ").concat(Spacing.x3);
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.xl;
}, function (_a) {
    var Colors = _a.theme.Colors, curriculum = _a.curriculum;
    return Colors.Curriculum[curriculum].main;
}, function (_a) {
    var Colors = _a.theme.Colors, curriculum = _a.curriculum;
    return Colors.Curriculum[curriculum].action;
}, function (_a) {
    var Colors = _a.theme.Colors, curriculum = _a.curriculum;
    return Colors.Curriculum[curriculum].action;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('both');
}, function (_a) {
    var Colors = _a.theme.Colors, curriculum = _a.curriculum;
    return Colors.Curriculum[curriculum].hover;
}, function (_a) {
    var Colors = _a.theme.Colors, curriculum = _a.curriculum;
    return Colors.Curriculum[curriculum].hover;
});
var templateObject_1;
